import { AxiosInstance } from "axios";

import { ResponseType } from "@/types/api";
import { ContactResType, ContactType, RequestResType, RequestType, TalentResType, TalentType } from "@/types/user";

class UserAPI {
  private axios;
  private baseUrl;

  constructor(axios: AxiosInstance, baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
  }

  postRequestList = async (requestForm: RequestType) => {
    const response = await this.axios.post<ResponseType<RequestResType>>(`${this.baseUrl}/list-request`, requestForm);
    return response.data;
  };

  postContact = async (contactForm: ContactType) => {
    const response = await this.axios.post<ResponseType<ContactResType>>(`${this.baseUrl}/request`, contactForm);
    return response.data;
  };

  postTalent = async (talentForm: TalentType) => {
    const response = await this.axios.post<ResponseType<TalentResType>>(`${this.baseUrl}/talent`, talentForm);
    return response.data;
  };
}

export default UserAPI;
